<div class="container">
  <h4 class="text-center"><strong>Click View Info</strong></h4>
  <div class="products" style="background: white; padding-top: 0; min-height: auto; ">
    <div class="content-container">
      <div class="text-center" style="padding-bottom: 0;">
        <h1 class="title-default intro-title" style="padding-top: 0;">
          Jompay
        </h1>
        <hr class="yellow-line-large" />
        <p class="text-intro"></p>
      </div>
      <div class="inner" style="padding-bottom: 0;">
        <div class="flex-wrap scroll_checklist">
          <form
            name="offer-letter-form"
            id="offer-letter-form"
            data-k2-validation="true"
            novalidate
            class="col-sm-8 general-form"
            style="padding: 0"
          >
            <div class="row">
              <div class="col-md-12">
                <p class="vmid">
                  Congratulation! Your application for <strong>Jompay Services </strong> is
                  approved. You may download Letter of Offer, Service Agreement
                  and Upliftment of Collection Account Blocking letter & Letter of Authorization.
                </p>
              </div>
            </div>

            <!-- <div class="row">
                <div class="col-xs-10 col-xs-offset-1 col-md-9 col-md-offset-0 " >
                  <h4>Letter of Offer</h4>
                </div>               

                <div class="col-xs-8 col-xs-offset-2 col-md-3 col-md-offset-0 ">
                  <a (click)="downloadPDF()" class="btn btn-default btn-block btn-checklist pointer">Download</a>
                  <a #oldownload download="randomFileName.pdf" [href]="offerletterSrc"  hidden></a>
                </div>
                
              </div> -->
            <div class="row">
              <div *ngIf="offerletterSrc" class="col-md-6 text-center">
                <h3>Letter of Offer</h3>
                <button  type="button" class="btn btn-primary btn-block center" (click)="downloadPDF('offerLetter')" >
                  Download
                </button>
                <a  #offerLetter download="randomFileName.pdf" [href]="offerletterSrc" target="_blank" hidden></a>
              </div>
              <div *ngIf="serviceAgreementSrc" class="col-md-6 text-center">
                <h3>Service Agreement</h3>
                <button type="button" class="btn btn-primary btn-block center" (click)="downloadPDF('serviceAgreement')">
                  Download
                </button>
                <a #serviceAgreement download="randomFileName.pdf" [href]="serviceAgreementSrc" target="_blank" hidden ></a>
              </div>
              <div class="col-md-6 text-center" style="padding-bottom: 0;">
                <h3>Upliftment of Collection Account Blocking letter & Letter of Authorization</h3>
                <button type="button" class="btn btn-primary btn-block center" (click)="downloadPDF('authLetterCollectionAcc')" >
                  Download
                </button>
                <a #authLetterCollectionAcc [href]="authLetterCollectionAccSrc" target="_blank" hidden ></a>
              </div>
            </div>            
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
